export const initPostsPagination = () => {
  const buttons = document.querySelectorAll('[data-load-more]');

  if (!buttons.length) {
    return;
  }

  buttons.forEach((button) => {
    const list = button.closest('section')?.querySelector('[data-posts-list]');

    if (!list) {
      return;
    }

    button.addEventListener('click', async () => {
      const currentPage = Number(button.dataset.page);
      const nextPage = currentPage + 1;
      const postType = button.dataset.postType;

      button.disabled = true;

      try {
        const response = await fetch(
          `${window.wpApiSettings.root}my-app/v1/load-posts/?post_type=${postType}&page=${nextPage}`
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || 'Ошибка загрузки записей');
        }

        if (result.html) {
          list.insertAdjacentHTML('beforeend', result.html);
          button.dataset.page = String(nextPage);
        }

        if (nextPage >= result.max_pages) {
          button.remove();
          return;
        }

        button.disabled = false;
      } catch (error) {
        console.error(error);
        button.disabled = false;
      }
    });
  });
};